// extracted by mini-css-extract-plugin
export default {"drawer":"CandidateDrawer-index__drawer--XmBZB"};